import { render, staticRenderFns } from "./BackBarDrinksTwoColumnSection.vue?vue&type=template&id=208668fe&scoped=true"
import script from "./BackBarDrinksTwoColumnSection.vue?vue&type=script&lang=ts"
export * from "./BackBarDrinksTwoColumnSection.vue?vue&type=script&lang=ts"
import style0 from "./BackBarDrinksTwoColumnSection.vue?vue&type=style&index=0&id=208668fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208668fe",
  null
  
)

export default component.exports